import { createAsyncThunk } from '@reduxjs/toolkit';

import { PLACEMENTS } from 'store/common/recommendations/constants';
import { fetchRecommendedDevices } from 'store/common/recommendations/actions';
import { getIsDigineticaRecommendsAvailable } from 'store/common/settings/selectors';

export const fetchRecommendedCrossSellDevices = createAsyncThunk(
  'crossSell/fetchRecommendedCrossSellDevices',
  async (_, { dispatch }) => dispatch(fetchRecommendedDevices(PLACEMENTS.BASKET)),
  {
    condition: (_, { getState }) => getIsDigineticaRecommendsAvailable(getState()),
  },
);
